import { createContext } from "react";
import { UserData } from "../interfaces/UserData";
export const UserContext = createContext<UserData>({
  isLoggedIn: false,
  address: "",
  isHolderOfCollection: false,
  ts: ""
});